/**
 * First Sale Tracker Model
 *
 * Frontend model instance for the first_sale_tracker table.
 * Represents a single tracker record with status, timestamps, and user ownership.
 */

import BaseModelInstance from './base.model'
import { FirstSaleTracker as ModelDefinition } from './model-definitions'

class FirstSaleTracker extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default FirstSaleTracker
